var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-text-field',_vm._g(_vm._b({attrs:{"hide-details":"auto","dense":"","type":_vm.type,"append-icon":_vm.icon},on:{"click:append":function($event){return _vm.toggleShowPassword()}}},'app-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }